import { useDrupalSettingsContext } from "~/contexts/DrupalSettingsContext";
import { createSignal, Show } from "solid-js";
import { gotoUrlWithUtm } from "~/utils/url";

import "./HeadBand.css";

import IconClose from "~/img/icons/close.svg";
import { makePersisted } from "@solid-primitives/storage";

export default function HeadBand() {
  const settingsContext = useDrupalSettingsContext();
  const headband = settingsContext.headband;

  // eslint-disable-next-line solid/reactivity
  const [show, setShow] = makePersisted(createSignal(true), {
    name: "headband",
  });

  const display = () => {
    // test local storage then fallback to signal
    const local = localStorage.getItem("headband");
    if (local) {
      return local === "true";
    }
    return show();
  };

  return (
    <>
      <Show when={display()}>
        <section
          class="cog-headband"
          style={{ background: headband.bg_color, color: headband.text_color }}
          data-test="headband"
        >
          <div class="text-part" innerHTML={settingsContext.headband.body} />

          <Show when={headband.button_url && headband.button_text}>
            <button
              class="btn"
              onClick={() => gotoUrlWithUtm(headband.button_url!)}
              style="color: {{ headband.text_color }} !important;"
              data-test="btn"
            >
              {headband.button_text}
            </button>
          </Show>
          <button
            type="button"
            class="btn btn-icon close"
            aria-label="Fermer"
            onClick={() => setShow(false)}
            data-test="btn-close"
          >
            <i
              aria-hidden="true"
              class="cog-icon"
              style={{ color: headband.text_color }}
            >
              <IconClose />
            </i>
          </button>
        </section>
      </Show>
    </>
  );
}
